import { render, staticRenderFns } from "./communicationDashboardHyroxPFT.vue?vue&type=template&id=3d49a9e2&scoped=true"
import script from "./communicationDashboardHyroxPFT.vue?vue&type=script&lang=js"
export * from "./communicationDashboardHyroxPFT.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardHyroxPFT.vue?vue&type=style&index=0&id=3d49a9e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d49a9e2",
  null
  
)

export default component.exports